import {
  CreateJobInput,
  CreateJobMutationVariables,
  UpdateJobInput,
  UpdateJobMutationVariables,
} from '@/API';
import {
  CreateJobMutation,
  UpdateJobMutation,
  createJobWithConnection as createJobMutation,
  updateJobWithConnection as updateJobMutation,
} from '@/appsync/graphql/job';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';

export const createJob = async (job: CreateJobInput): Promise<void> => {
  const variables: CreateJobMutationVariables = {
    input: job,
  };

  await graphqlQuery<CreateJobMutation, CreateJobMutationVariables>(
    createJobMutation,
    variables
  );
};

export const updateJob = async (job: UpdateJobInput): Promise<void> => {
  const variables: UpdateJobMutationVariables = {
    input: job,
  };

  await graphqlQuery<UpdateJobMutation, UpdateJobMutationVariables>(
    updateJobMutation,
    variables
  );
};
